<div>{{ activity.model.introductionText }}</div>
